import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["alt", "src", "srcset", "loading", "width", "height"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["srcset", "type"]
const _hoisted_4 = ["alt", "src", "srcset", "loading", "width", "height"]

import { type PropType, getCurrentInstance, onMounted, ref } from "vue";
import { elementVisible } from "../../../frontend-productgallery/element-intersection";

export default /*@__PURE__*/_defineComponent({
  __name: 'media-gallery-image',
  props: {
    enforceAspectRatio: {
        type: Boolean,
    },
    value: {
        type: String,
        required: true,
    },
    srcset: String,
    alt: String,
    size: {
        type: Object as PropType<{
            width: number;
            height: number;
        }>,
    },
    sources: {
        type: Array as PropType<
            {
                srcset: string;
                type: string;
            }[]
        >,
    },
    lazy: Boolean,
},
  setup(__props) {

const invisible = ref(true);


const instance = getCurrentInstance();
onMounted(() => {
    if (instance == null) throw new Error("missing instance");
    if (instance.proxy == null) throw new Error("instance proxy is null");
    invisible.value = elementVisible(instance.proxy.$el as HTMLElement) === 0;
});

return (_ctx: any,_cache: any) => {
  return (__props.sources == null || __props.sources.length === 0)
    ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        alt: __props.alt,
        class: "view-media",
        src: __props.value,
        srcset: __props.srcset,
        loading: __props.lazy || invisible.value ? 'lazy' : undefined,
        width: __props.size != null ? __props.size.width : undefined,
        height: __props.size != null ? __props.size.height : undefined,
        style: _normalizeStyle({
            'aspect-ratio':
                __props.size != null && __props.enforceAspectRatio
                    ? `${__props.size.width} / ${__props.size.height}`
                    : undefined,
        })
      }, null, 12 /* STYLE, PROPS */, _hoisted_1))
    : (_openBlock(), _createElementBlock("picture", _hoisted_2, [
        (__props.sources != null)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.sources, (source) => {
              return (_openBlock(), _createElementBlock("source", {
                srcset: source.srcset,
                type: source.type
              }, null, 8 /* PROPS */, _hoisted_3))
            }), 256 /* UNKEYED_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("img", {
          alt: __props.alt,
          class: "view-media",
          src: __props.value,
          srcset: __props.srcset,
          loading: __props.lazy || invisible.value ? 'lazy' : undefined,
          width: __props.size != null ? __props.size.width : undefined,
          height: __props.size != null ? __props.size.height : undefined,
          style: _normalizeStyle({
                'aspect-ratio':
                    __props.size != null && __props.enforceAspectRatio
                        ? `${__props.size.width} / ${__props.size?.height}`
                        : undefined,
            })
        }, null, 12 /* STYLE, PROPS */, _hoisted_4)
      ]))
}
}

})